import type { DashboardSample } from "./dashboard-model";

/**
 * The parts of the dashboard no endpoint answers yet.
 *
 * Shipped as fixed sample data on purpose (the PM call): the exceptions need a
 * suspended/manual-validation event vocabulary the service does not have yet.
 * The screen marks them as sample data rather than passing them off as live.
 *
 * Each field is shaped like what the real read will produce, so wiring one up
 * replaces a line here with a hook and touches no component.
 */
export const DASHBOARD_SAMPLE: DashboardSample = {
  exceptions: [
    {
      id: "x1",
      kind: "suspended",
      severity: "actionable",
      selector: "Priya Cohen",
      taskId: "4030",
      detail: "Task suspended mid-route in Cold — needs reassignment",
      ageMinutes: 74,
    },
    {
      id: "x2",
      kind: "suspended",
      severity: "actionable",
      selector: "Liam Ivanov",
      taskId: "4029",
      detail: "Task suspended mid-route in Freezer — needs reassignment",
      ageMinutes: 68,
    },
    {
      id: "x3",
      kind: "suspended",
      severity: "actionable",
      selector: "Ethan Cruz",
      taskId: "4028",
      detail: "Task suspended mid-route in Cold — needs reassignment",
      ageMinutes: 52,
    },
    {
      id: "x4",
      kind: "manualValidation",
      severity: "actionable",
      selector: "Noah Vargas",
      taskId: "4025",
      detail:
        "No barcode — completed via manual pick flow · Chicken Nuggets 5 lb",
      ageMinutes: 33,
    },
    {
      id: "x5",
      kind: "manualValidation",
      severity: "actionable",
      selector: "Diego Ivanov",
      taskId: "4019",
      detail:
        "Barcode damaged — completed via manual pick flow · Basmati Rice 20 lb",
      ageMinutes: 18,
    },
    ...[3, 7, 12, 15, 21, 26, 41].map((age, i) => ({
      id: `i${i}`,
      kind: "manualValidation" as const,
      severity: "informational" as const,
      selector: "Selector",
      taskId: String(4000 + i),
      detail: "Manual pick flow used — already validated",
      ageMinutes: age,
    })),
  ],
};
